import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import IpiCstService from 'business/cadastro/fiscal/ipiCst/ipiCstService'
import ControllerInput from 'base/ControllerInput'
import GridForm from 'base/GridForm'
import { yupResolver } from '@hookform/resolvers/yup'
import FormCadastro, { FormCadastroAux } from 'base/FormCadastro'
import { TabView, TabPanel } from 'primereact/tabview'
import { createCodeDescriptionObject, } from 'helper/formater'
import { errorToToast } from 'helper/error'

import TipoFluxoService from 'business/cadastro/fiscal/tipoFluxo/tipoFluxoService'

export default function IpiCst() {

    const [service] = useState(() => new IpiCstService())
    const [tipoFluxos, setTipoFluxos] = useState([])
    const stepperRef = useRef(null)
    const toast = useRef(null)
    const { id } = useParams()
    const [validations, setValidations] = useState([])

    const form = useForm({
        defaultValues: async () => await load(),
        resolver: yupResolver(validations),
        mode: "onBlur"
    })

    async function load() {
        const data = await FormCadastroAux.load({ id, service, toast, beforeSubmit, useNew: true })

        if (data?.tipo_fluxo) {
            setTipoFluxos([createCodeDescriptionObject(data.tipo_fluxo, 'codigo_tiflu', 'descricao_tiflu', true)])
        }

        return data
    }

    const beforeSubmit = (data) => {
        let submitData = structuredClone(data)
        submitData = service.prepareToSave({ data: submitData })
        return submitData
    }

    useEffect(() => {
        service.getSchema().then(e => {
            setValidations(e)
        })
    }, [service])

    const loadTipoFluxos = async () => {
        const srv = new TipoFluxoService()
        await srv.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_tiflu', 'descricao_tiflu', true))
            setTipoFluxos(options)
        }).catch(err => errorToToast({ err, toast }))
    }

    return (
        < FormCadastro service={service} form={form} aux={FormCadastroAux} toast={toast} beforeSubmit={beforeSubmit}>

            <TabView ref={stepperRef} className='text-sm' style={{ flexBasis: '1rem' }}>

                <TabPanel header="Capa" leftIcon="pi pi-home mr-2">

                    <GridForm>

                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-4" field="descricao_ipicst" form={form} service={service} type="text" clearString label="Descrição" />

                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_tiflu_ipicst" form={form} type="dropdown2" service={service} label="Tipo de fluxo"
                            optionKey='codigo_tiflu'
                            optionLabel='descricao_tiflu'
                            options={tipoFluxos}
                            onLoad={loadTipoFluxos}
                        />

                    </GridForm>

                </TabPanel>
                <TabPanel header="Info" leftIcon="pi pi-info-circle mr-2" visible={id > 0}>
                    <GridForm>
                    </GridForm>
                </TabPanel>

            </TabView>

        </FormCadastro>
    )
}
